"use client";

import React from "react";
import { motion } from "framer-motion";
import { PageHomeSchema } from "@/sanity/pages/PageHomeTemplate";
import Video from "@/components/global/Video";
import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { SanityVideoPlayer } from "@/components/ui/SanityVideoPlayer";
import PartnersBar from "@/components/pageComponents/global/PartnersBar";
import ScrollingPartnersLogos from "../global/ScrollingPartnersLogos";

const ease = [0.25, 0.1, 0.25, 1] as const;

export default function IntroSection({ data }: { data: PageHomeSchema }) {
  return (
    <section className="relative z-10 flex w-full flex-col items-center bg-[#001B14] py-[8rem] lg:w-[229.875rem] lg:py-[15rem]">
      <div className="container flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease }}
          className="flex flex-col items-center gap-[1.25rem] text-center">
          {data?.introChip && (
            <p className="mb-0 font-blacker text-[2.25rem] leading-[1.5] text-white italic">{data.introChip}</p>
          )}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease, delay: 0.35 }}
            className="richtext prose-p:text-white prose-headings:text-white">
            <PortableText
              value={data.introTitle}
              components={richTextComponent}
            />
          </motion.div>
        </motion.div>
      </div>

      {/* Video card */}
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease, delay: 0.3 }}
        className="relative mt-[7.25rem] w-full lg:h-[66.125rem] lg:w-[min(117.5rem,calc(100%-4rem))]">
        {data?.introVideo && (
          <SanityVideoPlayer
            className="!rounded-none lg:!rounded-[0.625rem]"
            playerData={data?.introVideo}
          />
        )}

        {/* Partners bar */}
        {/* <PartnersBar
          className="absolute bottom-[-3rem] left-1/2 z-10 w-[43.25rem] -translate-x-1/2 drop-shadow-[0_3.5rem_4.106rem_#004332] lg:bottom-[-4.25rem] lg:w-[min(69.125rem,100%)]"
          partnerText={data?.introPartnerText}
          partnerLogo1={data?.introPartnerLogo1}
          partnerLogo2={data?.introPartnerLogo2}
          trustpilotRating={data?.trustpilotRating}
        /> */}
      </motion.div>

      <ScrollingPartnersLogos
        logos={data.partnersLogos ?? []}
        label={data?.introPartnersLogoLabel ?? "Partner's Trusting IQ Capital"}
        theme="dark"
        className="mt-[4rem]"
      />

      {/* Teal divider */}
      <div className="absolute bottom-0 left-1/2 h-[0.75rem] w-[43rem] -translate-x-1/2 lg:w-[128.5rem]">
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.2, ease, delay: 0.6 }}
          className="h-full w-full bg-[#3B6162]"
          style={{ originX: 0.5 }}
        />
      </div>
    </section>
  );
}
